module.exports = __webpack_public_path__ + "img/f-thermometer-img6-2.496ab282.png";